import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedInIcon } from './SocialIcons';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            <FooterBrand />
            <FooterQuickLinks />
            <FooterResources />
            <FooterContact />
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          Copyrights &copy; 2024 Stupa Developmental Foundation. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

function FooterBrand() {
  return (
    <div className="footer-brand">
      <div className="footer-logo">
        <div className="footer-logo-icon"><GlobeIcon /></div>
        <span className="footer-logo-text">STUPA</span>
      </div>
      <p>Building a future that empowers communities to achieve self-reliance in harmony with nature.</p>
      <div className="footer-social">
        <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><LinkedInIcon /></a>
      </div>
    </div>
  );
}

function FooterQuickLinks() {
  return (
    <div>
      <h4 className="footer-heading">Quick Links</h4>
      <ul className="footer-links">
        <li><Link to="/about">About Us</Link></li>
        <li><Link to="/focus-area">Focus Area</Link></li>
        <li><Link to="/contact">Contact Us</Link></li>
      </ul>
    </div>
  );
}

function FooterResources() {
  return (
    <div>
      <h4 className="footer-heading">Resources</h4>
      <ul className="footer-links">
        <li><Link to="/our-story">Our Story</Link></li>
        <li><Link to="/project-gallery">Project Gallery</Link></li>
        <li><Link to="/contact">Help</Link></li>
      </ul>
    </div>
  );
}

function FooterContact() {
  return (
    <div>
      <h4 className="footer-heading">Contact Us</h4>
      <ContactItem icon={<LocationIcon />}>
        Head Office - B-231, First Floor, Greater Kailash Part I, New Delhi-110048
      </ContactItem>
      <ContactItem icon={<PhoneIcon />}>
        <a href="tel:01145092961" className="footer-link-inline">Phone 011 45092961</a>
      </ContactItem>
      <ContactItem icon={<MailIcon />}>
        <a href="mailto:info@stupadev.com" className="footer-link-inline">info@stupadev.com</a>
      </ContactItem>
    </div>
  );
}

function ContactItem({ icon, children }) {
  return (
    <div className="footer-contact-item">
      <span className="footer-contact-icon">{icon}</span>
      <span>{children}</span>
    </div>
  );
}

function GlobeIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="#52B788" strokeWidth="1.5" width="24" height="24">
      <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  );
}

function LocationIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="18" height="18">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="18" height="18">
      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="18" height="18">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  );
}

export default Footer;
